<template>
    <div :class="{'card': true, 'card-collapsed': collapsed}">
        <div class="card-header bg-light header-elements-inline" v-if="title">
            <h6 class="card-title">{{ title }}</h6>
            <div class="header-elements">
                <slot name="header-elements"></slot>
                <div class="list-icons">
                    <a class="list-icons-item" data-action="collapse"></a>
                </div>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'CardComponent',
    props: {
        title: {
            type: String,
            required: false
        },
        collapsed: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style scoped>

</style>
